<template>
  <div>
    <div class="center grey-shallow font20">
      查询货号 <span class="grey">{{ productNo }}</span> 颜色
      <span class="grey">{{ color }}</span> 的结果
    </div>

    <div class="wrapper table-area">
      <vxe-table
        :data="groupBoms"
        :span-method="mergeMethod"
        id="bomsTable"
        row-id="id"
        ref="groupBomsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        border
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="materialSerialNo"
          :title="$t('material.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isSubject"
              >{{ row.material.serialNo }}
              <div class="font8">
                {{ $t("material.handCycle") }}:{{
                  row.material.minHandCycle
                }}-{{ row.material.maxHandCycle }}
              </div>
            </span>
            <div v-else class="flex flex-between">{{ row.subject }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="name"
          :title="$t('material.name')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.material">{{ row.material.name }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="baseQuantity"
          :title="$t('material.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.baseQuantity }}
            <span v-if="row.material">{{ row.material.unit }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="color"
          :title="$t('material.color')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.material"
              >{{ row.material.color }}({{ row.material.colorNo }})</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="sizeQuantities"
          :title="$t('material.sizeQuantity')"
          min-width="120"
        >
          <template v-slot="{ row }">
            <div
              v-for="(sizeQuantity, sizeQuantityIdx) of row.sizeQuantities"
              :key="sizeQuantityIdx"
              class="font10"
            >
              {{ sizeQuantity.size }}：{{ sizeQuantity.quantity }}
              <span v-if="row.material">{{ row.material.unit }}</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="inventories"
          :title="$t('material.storeQuantity')"
          min-width="120"
        >
          <template v-slot="{ row }">
            <div v-if="row.material && row.material.inventories">
              <div
                v-for="(inventory, inventoryIdx) of row.material.inventories"
                :key="inventoryIdx"
                class="font10"
              >
                {{ inventory.warehouseName }}({{ inventory.shelf }})&nbsp;
                {{ inventory.storeQuantity }}{{ row.material.unit }}
              </div>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="6" />
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Product from "@/api/product.js";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      Util: Util,
      productNo: null,
      color: null,
      boms: [],
      groupBoms: [],
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    self.productNo = this.$route.query.productNo;
    self.color = this.$route.query.color;

    Product.findByProductNo({
      productNo: self.productNo,
    }).then(function (res) {
      self.loadingEnd();
      if (res.data.code === 200) {
        Product.bomsFindByProductInfoWithQty(res.data.entity.id, {
          productNo: self.productNo,
          color: self.color,
        }).then(function (res) {
          if (res.status === 200) {
            self.boms = res.data;
            self.buildTableData();
          } else {
            self.sysError();
          }
        });
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    buildTableData() {
      const self = this;
      self.groupBoms = [];
      if (self.boms.length === 0) {
        return;
      }
      const bomsNoMaterial = self.boms.filter((b) => b.material == null);
      const boms = self.boms.filter((b) => b.material != null);
      if (boms.length != 0) {
        const subjectIds = boms.map((b) => b.material.subjectId);
        const subjectIdsSet = [...new Set(subjectIds)];
        for (const subjectId of subjectIdsSet) {
          const currentSubjectBoms = self.boms.filter(
            (b) => b.material.subjectId == subjectId
          );
          self.groupBoms.push({
            id: subjectId,
            subject: currentSubjectBoms[0].material.subjectName,
            isSubject: true,
            boms: currentSubjectBoms,
            subjectTotal: self.computeSubjectTotal(currentSubjectBoms),
          });
          for (const bom of currentSubjectBoms) {
            self.groupBoms.push(bom);
          }
        }
      }
      if (bomsNoMaterial.length != 0) {
        self.groupBoms.push({
          id: -1,
          subject: " ",
          boms: bomsNoMaterial,
        });
        for (const bom of bomsNoMaterial) {
          self.groupBoms.push(bom);
        }
      }
    },
    computeSubjectTotal(currentSubjectBoms) {
      let total = 0;
      for (const b of currentSubjectBoms) {
        total = total + b.baseQuantity * b.material.price;
      }
      return total;
    },
    buildMergeCells() {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < this.groupBoms.length; i++) {
        mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 7 });
        if (this.groupBoms[i].boms) {
          rowIdx = rowIdx + this.groupBoms[i].boms.length + 1;
        }
      }
      return mcs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.buildMergeCells();
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
  },
};
</script>
<style scoped>
</style>
